(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['../ApiClient', '../model/CreateFileResp', '../model/CreateFileRequest', '../model/ApiDocDataWrapperString', '../model/ContentCreationResp', '../model/ImportFileRequest', '../model/ApiDocListFileResp'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/CreateFileResp'), require('../model/CreateFileRequest'), require('../model/ApiDocDataWrapperString'), require('../model/ContentCreationResp'), require('../model/ImportFileRequest'), require('../model/ApiDocListFileResp'));
  } else {
    // Browser globals (root is window)
    if (!root.SmartCsV2Sdk) {
      root.SmartCsV2Sdk = {};
    }
    root.SmartCsV2Sdk.VcloudgdApi = factory(root.SmartCsV2Sdk.ApiClient, root.SmartCsV2Sdk.CreateFileResp, root.SmartCsV2Sdk.CreateFileRequest, root.SmartCsV2Sdk.ApiDocDataWrapperString, root.SmartCsV2Sdk.ContentCreationResp, root.SmartCsV2Sdk.ImportFileRequest, root.SmartCsV2Sdk.ApiDocListFileResp);
  }
}(this, function(ApiClient, CreateFileResp, CreateFileRequest, ApiDocDataWrapperString, ContentCreationResp, ImportFileRequest, ApiDocListFileResp) {
  'use strict';

  /**
   * Vcloudgd service.
   * @module api/VcloudgdApi
   * @version 2.0.624
   */

  /**
   * Constructs a new VcloudgdApi. 
   * @alias module:api/VcloudgdApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use, default to {@link module:ApiClient#instance}
   * if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the create operation.
     * @callback module:api/VcloudgdApi~createCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CreateFileResp} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Create a file on the cloud drive
     * &lt;p&gt;
     * @param {module:model/String} cloudVendor 
     * @param {module:model/CreateFileRequest} req 
     * @param {module:api/VcloudgdApi~createCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/CreateFileResp}
     */
    this.create = function(cloudVendor, req, callback) {
      var postBody = req;

      // verify the required parameter 'cloudVendor' is set
      if (cloudVendor == undefined || cloudVendor == null) {
        throw "Missing the required parameter 'cloudVendor' when calling create";
      }

      // verify the required parameter 'req' is set
      if (req == undefined || req == null) {
        throw "Missing the required parameter 'req' when calling create";
      }


      var pathParams = {
      };
      var queryParams = {
        'cloudVendor': cloudVendor
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = [];
      var returnType = CreateFileResp;

      return this.apiClient.callApi(
        '/v2/cloud/file', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the download operation.
     * @callback module:api/VcloudgdApi~downloadCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ApiDocDataWrapperString} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Request a download link for a google drive file
     * &lt;p&gt;\n The User must has a token from a platform which integrated with Google drive.
     * @param {module:model/String} cloudVendor The cloud vendor to use
     * @param {String} fileId The file id on cloud drive
     * @param {module:api/VcloudgdApi~downloadCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/ApiDocDataWrapperString}
     */
    this.download = function(cloudVendor, fileId, callback) {
      var postBody = null;

      // verify the required parameter 'cloudVendor' is set
      if (cloudVendor == undefined || cloudVendor == null) {
        throw "Missing the required parameter 'cloudVendor' when calling download";
      }

      // verify the required parameter 'fileId' is set
      if (fileId == undefined || fileId == null) {
        throw "Missing the required parameter 'fileId' when calling download";
      }


      var pathParams = {
        'fileId': fileId
      };
      var queryParams = {
        'cloudVendor': cloudVendor
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = [];
      var returnType = ApiDocDataWrapperString;

      return this.apiClient.callApi(
        '/v2/cloud/download/{fileId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the importFile operation.
     * @callback module:api/VcloudgdApi~importFileCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Import a file from a Cloud vendor to CS
     * &lt;p&gt;
     * @param {module:model/String} cloudVendor 
     * @param {module:model/ImportFileRequest} request 
     * @param {module:api/VcloudgdApi~importFileCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.importFile = function(cloudVendor, request, callback) {
      var postBody = request;

      // verify the required parameter 'cloudVendor' is set
      if (cloudVendor == undefined || cloudVendor == null) {
        throw "Missing the required parameter 'cloudVendor' when calling importFile";
      }

      // verify the required parameter 'request' is set
      if (request == undefined || request == null) {
        throw "Missing the required parameter 'request' when calling importFile";
      }


      var pathParams = {
      };
      var queryParams = {
        'cloudVendor': cloudVendor
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = [];
      var returnType = null;

      return this.apiClient.callApi(
        '/v2/cloud/file/import', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the list operation.
     * @callback module:api/VcloudgdApi~listCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ApiDocListFileResp} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * List or Query for Files
     * &lt;p&gt;\n\n List or use other filters to retrieve files on cloud storage
     * @param {module:model/String} cloudVendor 
     * @param {Object} opts Optional parameters
     * @param {module:model/String} opts.resourceType 
     * @param {String} opts.folderId 
     * @param {String} opts.nextPageToken 
     * @param {Integer} opts.limit 
     * @param {module:api/VcloudgdApi~listCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/ApiDocListFileResp}
     */
    this.list = function(cloudVendor, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'cloudVendor' is set
      if (cloudVendor == undefined || cloudVendor == null) {
        throw "Missing the required parameter 'cloudVendor' when calling list";
      }


      var pathParams = {
      };
      var queryParams = {
        'cloudVendor': cloudVendor,
        'resourceType': opts['resourceType'],
        'folderId': opts['folderId'],
        'nextPageToken': opts['nextPageToken'],
        'limit': opts['limit']
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = [];
      var returnType = ApiDocListFileResp;

      return this.apiClient.callApi(
        '/v2/cloud/file/list', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
